import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import Stepper from '../../components/Stepper/Stepper';
import Selector from '../../components/Selector/Selector';
import SelectorVertical from '../../components/SelectorVertical/SelectorVertical';
import Recommendations from '../../components/Recommendations/Recommendations';

class StepThree extends Component {
  componentDidMount() {
    if(process.env.PUBLIC_URL) {
      const pathname = `${process.env.PUBLIC_URL}/step3`;
      ReactGA.pageview(pathname);
    }
  }
  render() {
    const {
      selectedFirst,
      selectedSecond,
      areaCode,
      currentService,
      selectedTab,
      selectedService,
      selectedTV,
      selectedInternet,
      selectedPhone,
      recomendedPlans,
      choosedPlans,
      showAll,
      dispatchSelectTab,
      dispatchSelectService,
      dispatchSelectTV,
      dispatchSelectInternet,
      dispatchSelectPhone,
      dispatchToggleShowAll,
    } = this.props;

    if (!selectedTab.length) {
      this.props.history.push({ pathname: `${process.env.PUBLIC_URL}/step1` })
    }

    const stepNumber = 3;
    const isMobile = window.innerWidth <= 960;
    const serviceOption = isMobile ? 'サービスから選択' : 'ほしいサービスから選択';

    const isHakusanroku = areaCode === 3;

    const questionService = currentService.indexOf(0) >= 0 ? 'ご利用中のサービスを選択してください。' : 'ご利用したいサービスを選択してください。';
    const questionTV = '見たいテレビ番組を選択してください。';
    const questionInternet = 'ご希望のインターネットコース（最大速度）を選択してください。';
    const questionPhone = 'ご希望の電話コースを選択してください。';
    const tabTitles =  [ 'オススメのプラン', serviceOption ];
    const optionsService = !isHakusanroku ? [ { title: 'テレビ' }, { title: 'インターネット' }, { title: '電話' }] : [ { title: 'テレビ' }, { title: 'インターネット' }];
    const optionsTV = [
      { title: '地上波 ＋ 地域限定 ＋ BS ＋ CS' },
      { title: '地上波 ＋ 地域限定 ＋ BS' },
      { title: '地上波 ＋ 地域限定' },
    ];
    const optionsInternet = [
      { title: '1G コース', desc: '何が何でも速度重視の方に', recomend: false },
      { title: '500M コース', desc: '1Gまでの速度ではないがちょっとおトクに楽しみたい方に', recomend: false },
      { title: '200M コース', desc: 'ネット動画やリモート授業はこれで十分', recomend: false },
    ];
    const optionsPhone = [
      { title: 'ケーブルプラス電話' },
      { title: 'ケーブルライン' },
    ];

    const handleDetail = plan => {
      this.props.history.push({
        pathname: `${process.env.PUBLIC_URL}/step4`,
        state: {
          plan,
          selectedFirst,
          selectedSecond,
          currentService,
          areaCode,
        },
      });
    }

    const onClickTab = selectedIndex => {
      dispatchSelectTab(selectedIndex);
    }

    const onClickService = selectedIndex => {
      dispatchSelectService(selectedIndex);
    }

    const onClickTV = selectedIndex => {
      dispatchSelectTV(selectedIndex);
    }

    const onClickInternet = selectedIndex => {
      dispatchSelectInternet(selectedIndex);
    }

    const onClickPhone = selectedIndex => {
      dispatchSelectPhone(selectedIndex);
    }

    const midStyle = {
      marginTop: 48,
    }

    const autoRecommendation = selectedTab.indexOf(0) >= 0;

    const serviceOptions = !autoRecommendation ? (
      <React.Fragment>
        <SelectorVertical
          title={questionService}
          options={optionsService}
          style={midStyle}
          must
          onClick={onClickService}
          selected={selectedService}
          check
          show
          titleOnly
        />
        <SelectorVertical
          title={questionTV}
          options={optionsTV}
          style={midStyle}
          must
          onClick={onClickTV}
          selected={selectedTV}
          show={selectedService.indexOf(0) >= 0}
          titleOnly
        />
        <SelectorVertical
          title={questionInternet}
          options={optionsInternet}
          style={midStyle}
          must
          onClick={onClickInternet}
          selected={selectedInternet}
          show={selectedService.indexOf(1) >= 0}
        />
        <SelectorVertical
          title={questionPhone}
          options={optionsPhone}
          style={midStyle}
          must
          onClick={onClickPhone}
          selected={selectedPhone}
          show={!isHakusanroku && selectedService.indexOf(2) >= 0}
          disable={!(selectedService.indexOf(1) >= 0 && selectedInternet.length) || selectedInternet.indexOf(4) >= 0}
          titleOnly
        />
      </React.Fragment>
    ) : null;

    const plans = autoRecommendation ? recomendedPlans : choosedPlans;
    const recommendations = (
      <Recommendations
        title="オススメのプラン"
        plans={plans}
        onClick={handleDetail}
        handleShowAll={dispatchToggleShowAll}
        showAll={showAll}
        phoneAlert={selectedService.length === 1 && selectedService[0] === 2}
      />
    );

    return (
      <div id="container" className="container" >
        <Stepper activeNumber={stepNumber} />
        <Selector
          options={tabTitles}
          style={midStyle}
          onClick={onClickTab}
          selected={selectedTab}
          tab
          charactor={selectedTab[0]}
          itemfalse
        />
        {serviceOptions}
        {recommendations}
      </div>
    );
  }
};

export default withRouter(StepThree);
